module.exports = __webpack_public_path__ + "static/media/payment-faq-tick.78121d82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment-faq-tick.svg
// module id = 2065
// module chunks = 0